/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PushNotificationPagedList } from '../../models/push-notification-paged-list';
import { PushNotificationSearchBody } from '../../models/push-notification-search-body';
import { SortDirection } from '../../models/sort-direction';

export interface GetPushNotificationList$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * CREATION_DATE : the start date
 *   * TYPE : the type of the notification
 *   * TITLE: the title of the notification
 *   * DELIVERY_DATE: the delivery date of the notification
 *   * DELIVERY_STATE: the delivery state of the notification
 */
  sortFieldName?: 'CREATION_DATE' | 'TYPE' | 'TITLE' | 'DELIVERY_DATE' | 'DELIVERY_STATE';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search push notification lists
     */
    body?: PushNotificationSearchBody
}

export function getPushNotificationList$Json(http: HttpClient, rootUrl: string, params?: GetPushNotificationList$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PushNotificationPagedList>> {
  const rb = new RequestBuilder(rootUrl, getPushNotificationList$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PushNotificationPagedList>;
    })
  );
}

getPushNotificationList$Json.PATH = '/custom/notifications/search';
